<div class="side-nav-body">
  <div class="align-right">
    <button
      [attr.aria-label]="'aria.close_side_menu' | translate"
      mat-icon-button
    >
      <i class="fas fa-times"></i>
    </button>
    <router-outlet name="sidebar"></router-outlet>
  </div>
</div>
